const value = {
    name: 'Название',
    description: 'Описание',
    ordering: 'Порядок отображения',
    orderingFormLabel: 'Порядок',
    active: 'Активен',
    notActive: 'Активен',
    showIfHaveValues: 'Показывать если есть значения',
    showIfHaveNotValues: 'Показывать если нет значений',
    status: 'Статус',
    category: 'Категория',
    categoryName: 'Категория - {{name}}',
    categoryUntitled: 'Без названия',
    categoryEntity: 'Сущности категории {{name}}',
  };

export default value;
